<template>
    <b-form-select :value="value" @input="$emit('input', $event)" size="sm" :disabled="disabled">
        <b-form-select-option :value="null">Default (No Patient Contact)</b-form-select-option>
        <b-form-select-option v-for="s in active" :key="s.id" :value="s.id">{{ s.name }}</b-form-select-option>
    </b-form-select>
</template>

<script lang="ts">
import axios from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

interface SubStatus { id: number; name: string; active: boolean; }

// Fetches /api/Prescription/OnHoldSubStatus once per mount and exposes it as a
// b-form-select. Pulled out so AutoProcessProductEditModal, AutoProcessBulkEditModal,
// and ProgramAutoProcessTab don't each carry their own fetch + filter + markup copy.
@Component({ name: 'OnHoldSubStatusSelect' })
export default class OnHoldSubStatusSelect extends Vue {
    @Prop({ default: null }) value!: number | null;
    @Prop({ default: false }) disabled!: boolean;

    private active: SubStatus[] = [];

    async created() {
        try {
            const resp = await axios.get<SubStatus[]>('/api/Prescription/OnHoldSubStatus');
            this.active = (resp.data ?? []).filter(s => s.active);
        } catch (e) {
            // Surface the failure — silently empty dropdowns let operators save
            // configs whose sub-status implications they can't see.
            this.active = [];
            (this as any).$notifications?.notify(NotificationOptions.error(e));
        }
    }
}
</script>
